import React from 'react';

import { FontAwesomeIcon } from '@medely/react-fontawesome';
import { InternalBox } from '@src/components/Box/InternalBox';
import { getPaletteColor } from '@src/utils/colors';
import { getIconVariantColors } from '../utils';
import type { InternalIconProps } from './interface';

export const InternalIcon = (props: InternalIconProps) => {
  const { iconSize = '16px', boxSize = '24px', icon } = props;
  const { color, bgColor } = getIconVariantColors(props);

  return (
    <InternalBox
      height={boxSize}
      width={boxSize}
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      borderRadius={boxSize}
      bgColor={bgColor}
    >
      <FontAwesomeIcon
        icon={icon}
        color={getPaletteColor(color)}
        style={{ fontSize: iconSize }}
      />
    </InternalBox>
  );
};
